// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1199px) {
  html.usuarios-page-lock {
    overflow: hidden;
  }

  body.usuarios-responsive-page #root {
    margin-left: 0 !important;
    overflow-x: hidden;
  }

  .usuarios .content-wrapper {
    height: calc(100dvh - 64px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .usuarios #layout-navbar.custom-navbar-admin {
    background: transparent !important;
    background-color: transparent !important;
    background-image: none !important;
    box-shadow: none !important;
  }

  .usuarios #layout-navbar {
    min-height: 64px;
    padding: 4px 12px 4px 8px;
  }

  .usuarios #layout-navbar .app-brand-link {
    min-width: 0;
    flex: 1 1 auto;
  }

  .usuarios #layout-navbar .app-brand-link img {
    width: min(190px, 100%);
    height: 56px !important;
    object-fit: contain;
    object-position: left center;
  }

  .usuarios #layout-navbar .navbar-nav-right {
    position: static;
    transform: none;
    flex: 0 0 auto;
  }

  .usuarios #layout-navbar .navbar-actions {
    gap: 4px;
  }
}

@media (max-width: 767px) {
  .usuarios .content-wrapper {
    height: calc(100dvh - 60px);
    padding-bottom: calc(76px + env(safe-area-inset-bottom));
  }

  .usuarios {
    min-height: 100dvh;
    overflow-x: hidden;
    background: #f5f7fb;
  }

  .usuarios #layout-navbar {
    min-height: 60px;
    padding: 4px 8px;
  }

  .usuarios #layout-navbar .app-brand-link img {
    width: min(172px, 100%);
    height: 48px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/usuariosResponsive.css"],"names":[],"mappings":"AAAA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,kCAAkC;IAClC,wCAAwC;IACxC,iCAAiC;IACjC,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,wDAAwD;EAC1D;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,uBAAuB;EACzB;AACF","sourcesContent":["@media (max-width: 1199px) {\n  html.usuarios-page-lock {\n    overflow: hidden;\n  }\n\n  body.usuarios-responsive-page #root {\n    margin-left: 0 !important;\n    overflow-x: hidden;\n  }\n\n  .usuarios .content-wrapper {\n    height: calc(100dvh - 64px);\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .usuarios #layout-navbar.custom-navbar-admin {\n    background: transparent !important;\n    background-color: transparent !important;\n    background-image: none !important;\n    box-shadow: none !important;\n  }\n\n  .usuarios #layout-navbar {\n    min-height: 64px;\n    padding: 4px 12px 4px 8px;\n  }\n\n  .usuarios #layout-navbar .app-brand-link {\n    min-width: 0;\n    flex: 1 1 auto;\n  }\n\n  .usuarios #layout-navbar .app-brand-link img {\n    width: min(190px, 100%);\n    height: 56px !important;\n    object-fit: contain;\n    object-position: left center;\n  }\n\n  .usuarios #layout-navbar .navbar-nav-right {\n    position: static;\n    transform: none;\n    flex: 0 0 auto;\n  }\n\n  .usuarios #layout-navbar .navbar-actions {\n    gap: 4px;\n  }\n}\n\n@media (max-width: 767px) {\n  .usuarios .content-wrapper {\n    height: calc(100dvh - 60px);\n    padding-bottom: calc(76px + env(safe-area-inset-bottom));\n  }\n\n  .usuarios {\n    min-height: 100dvh;\n    overflow-x: hidden;\n    background: #f5f7fb;\n  }\n\n  .usuarios #layout-navbar {\n    min-height: 60px;\n    padding: 4px 8px;\n  }\n\n  .usuarios #layout-navbar .app-brand-link img {\n    width: min(172px, 100%);\n    height: 48px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
